// Separate file for Livewire.on() registers that can then be imported into wellth and crbg main js.
import Swal from 'sweetalert2';

Livewire.on('alert', ({title, body, type}) => {
    Swal.fire({
        icon: type,
        title: title,
        text: body,
        confirmButtonColor: '#032b62'
    });
});
